import de from '@translations/de/profile.json';
import en from '@translations/en/profile.json';
import pl from '@translations/pl/profile.json';
import sl from '@translations/sl/profile.json';
import uk from '@translations/uk/profile.json';
import bg from '@translations/bg/profile.json';
import cz from '@translations/cz/profile.json';
import fr from '@translations/fr/profile.json';
import gr from '@translations/gr/profile.json';
import it from '@translations/it/profile.json';
import pr from '@translations/pr/profile.json';
import ru from '@translations/ru/profile.json';
import sk from '@translations/sk/profile.json';
import sp from '@translations/sp/profile.json';
import tr from '@translations/tr/profile.json';
import hu from '@translations/hu/profile.json';
import { ITranslations } from '@/types/common';
import { ProfileTransFields } from './types';

export const profileTranslations: ITranslations<ProfileTransFields> = {
  name: 'profile',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
